import useSWR from "swr";
import jwt_decode from "jwt-decode";

import baseClient, { getToken, setTokens, clearTokens } from 'api/baseClient';

function useUser() {

    const fetcher = async () => {

        const token = getToken();

        if (! token) {
            const error = new Error("No cookie!");
            error.status = 403;
            throw error;
        }

        const decodedToken = jwt_decode(token);

        const userResponse = await baseClient.get(`user/${decodedToken.user.id}`);

        return userResponse.data;
    }

    const { data, error, isLoading, mutate } = useSWR(
        'user',
        fetcher
    );

    const logout = () => {
        clearTokens();
        mutate(null);
    }

    const login = (tokenPair) => {
        setTokens(tokenPair);
        mutate();
    }

    return {
        userData: data,
        loggedOut: error ? true : false,
        isLoading,
        logout,
        login,
        mutateUser: mutate
    }
}

export default useUser;
